// declaration of all action types for filters slice here

export const STATUS_CHANGED = 'filters/statusChanged';
export const SEARCHED_BY_NAME = 'filters/searchedByName';